import { Plugin } from '@ckeditor/ckeditor5-core';
import { ClipboardPipeline } from '@ckeditor/ckeditor5-clipboard';
import { UpcastWriter } from '@ckeditor/ckeditor5-engine';
//here 
import { downcastVideoAttribute, upcastVideoFigure, } from './converters';
import VideoEditing from './videoediting';
import VideoTypeCommand from './videotypecommand';
import { createVideoViewElement, determineVideoTypeForInsertionAtSelection, getVideoViewElementMatcher } from './utils';
import VideoUtils from '../videoutils';
export default class VideoBlockEditing extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [VideoEditing, VideoUtils, ClipboardPipeline];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'VideoBlockEditing';
    }
    /**
     * @inheritDoc
     */
    init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        schema.register('videoBlock', {
            isObject: true,
            isBlock: true,
            allowWhere: '$block',
            allowAttributes: ['src', 'controls']
        });
        this._setupConversion();
        if (editor.plugins.has('VideoInlineEditing')) {
            editor.commands.add('videoTypeBlock', new VideoTypeCommand(this.editor, 'videoBlock'));
            this._setupClipboardIntegration();
        }
    }
    _setupConversion() {
        const editor = this.editor;
        const conversion = editor.conversion;
        const videoUtils = editor.plugins.get('VideoUtils');
        conversion.for('dataDowncast')
            .elementToElement({
            model: 'videoBlock',
            view: (modelElement, { writer }) => createVideoViewElement(writer, modelElement, 'videoBlock')
        });
        conversion.for('editingDowncast')
            .elementToElement({
            model: 'videoBlock',
            view: (modelElement, { writer }) => videoUtils.toVideoWidget(createVideoViewElement(writer, modelElement, 'videoBlock'), writer)
        });
        conversion.for('downcast')
            .add(downcastVideoAttribute(videoUtils, 'videoBlock', 'src'));
        conversion.for('upcast')
            .elementToElement({
            view: getVideoViewElementMatcher(editor, 'videoBlock'),
            model: (viewVideo, { writer }) => writer.createElement('videoBlock', viewVideo.hasAttribute('src') ? { src: viewVideo.getAttribute('src') } : undefined)
        })
            .add(upcastVideoFigure(videoUtils));
    }
    _setupClipboardIntegration() {
        const editor = this.editor;
        const model = editor.model;
        const editingView = editor.editing.view;
        const videoUtils = editor.plugins.get('VideoUtils');
        const clipboardPipeline = editor.plugins.get('ClipboardPipeline');
        this.listenTo(clipboardPipeline, 'inputTransformation', (evt, data) => {
            const docFragmentChildren = Array.from(data.content.getChildren());
            let modelRange;
            if (!docFragmentChildren.every(videoUtils.isInlineVideoView)) {
                return;
            }
            if (data.targetRanges) {
                modelRange = editor.editing.mapper.toModelRange(data.targetRanges[0]);
            }
            else {
                modelRange = model.document.selection.getFirstRange();
            }
            const selection = model.createSelection(modelRange);
            if (determineVideoTypeForInsertionAtSelection(model.schema, selection) === 'videoBlock') {
                const writer = new UpcastWriter(editingView.document);
                const blockViewVideos = docFragmentChildren.map(inlineViewVideo => writer.createElement('figure', { class: 'video' }, inlineViewVideo));
                data.content = writer.createDocumentFragment(blockViewVideos);
            }
        });
    }
}
//# sourceMappingURL=videoblockediting.js.map